"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const StorefrontAnalyticsTracker = dynamic(() => import("./StorefrontAnalyticsTracker"), { ssr: false });

export default function AnalyticsTracker() {
  const pathname = usePathname();
  return pathname.startsWith("/csat/") || pathname.startsWith("/delivery-feedback/")
    ? null
    : <StorefrontAnalyticsTracker />;
}
